<div
  class="grid"
  cdkDropList
  cdkDropListOrientation="mixed"
  [cdkDropListDisabled]="!reorderable || busy"
  (cdkDropListDropped)="onDrop($event)"
>
  @for (url of items; track url; let i = $index) {
    <div class="tile" cdkDrag [class.reorderable]="reorderable" [cdkDragDisabled]="!reorderable || busy">
      <img [src]="url" [alt]="'imageManager.photoAlt' | transloco: { n: i + 1 }" draggable="false" loading="lazy" />

      @if (reorderable && i === 0) {
        <span class="cover-badge"><mat-icon>star</mat-icon> {{ 'imageManager.cover' | transloco }}</span>
      }

      <div class="actions">
        @if (reorderable) {
          <button
            type="button"
            mat-icon-button
            [attr.aria-label]="'imageManager.moveEarlier' | transloco"
            [title]="'imageManager.moveEarlier' | transloco"
            [disabled]="busy || i === 0"
            (click)="move(i, i - 1)"
          >
            <mat-icon>chevron_left</mat-icon>
          </button>
          @if (i > 0) {
            <button
              type="button"
              mat-icon-button
              [attr.aria-label]="'imageManager.makeCover' | transloco"
              [title]="'imageManager.makeCover' | transloco"
              [disabled]="busy"
              (click)="move(i, 0)"
            >
              <mat-icon>star_outline</mat-icon>
            </button>
          }
          <button
            type="button"
            mat-icon-button
            [attr.aria-label]="'imageManager.moveLater' | transloco"
            [title]="'imageManager.moveLater' | transloco"
            [disabled]="busy || i === items.length - 1"
            (click)="move(i, i + 1)"
          >
            <mat-icon>chevron_right</mat-icon>
          </button>
        }
        <button
          type="button"
          mat-icon-button
          class="delete"
          [attr.aria-label]="'imageManager.deletePhoto' | transloco"
          [title]="'imageManager.deletePhoto' | transloco"
          [disabled]="busy"
          (click)="remove.emit(url)"
        >
          <mat-icon>delete</mat-icon>
        </button>
      </div>
    </div>
  }

  @if (items.length < max) {
    <label class="tile add" [class.disabled]="busy">
      <input
        type="file"
        multiple
        accept="image/*"
        [disabled]="busy"
        (change)="onPick($event)"
      />
      <mat-icon>add_a_photo</mat-icon>
      <span>{{ 'imageManager.addPhotos' | transloco }}</span>
    </label>
  }
</div>

<p class="ui-hint count">
  {{ 'imageManager.count' | transloco: { count: items.length, max } }}
  @if (reorderable && items.length > 1) {
    · {{ 'imageManager.dragHint' | transloco }}
  }
</p>
